import { render, staticRenderFns } from "./ActionsMenu.vue?vue&type=template&id=1bb94780&scoped=true&"
import script from "./ActionsMenu.vue?vue&type=script&lang=js&"
export * from "./ActionsMenu.vue?vue&type=script&lang=js&"
import style0 from "./ActionsMenu.vue?vue&type=style&index=0&id=1bb94780&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb94780",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VBtn,VCard,VIcon,VMenu,VOverlay})
